// src/api/utils.ts

import { BASE_URL } from "@project/shared-types";
import axios from "axios";

const getUrl = () => {
  if (typeof window === "undefined") {
    return "http://127.0.0.1:8009" + BASE_URL;
  }
  return window.location.origin + BASE_URL;
};
const apiClient = axios.create({
  baseURL: getUrl(), // Замените на ваш базовый URL
});
const getToken = () => {
  if (typeof window === "undefined") {
    return null;
  }
  const token = localStorage.getItem("token");
  return token ? token.replace(/"/g, "") : null;
};
const getAuthHeader = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
const apiFetchPost = async <TRequest, TResponse>(
  url: string,
  requestData: TRequest,
  headers: Record<string, string> = {}
): Promise<TResponse> => {
  const response = await apiClient.post<TResponse>(url, requestData, {
    headers: {
      ...headers,
      ...getAuthHeader(),
    },
  });
  return response.data;
};

export const apiUploadFile = async <TResponse>(
  url: string,
  file: File,
  additionalData: Record<string, any> = {},
  headers: Record<string, string> = {},
  onProgress?: (percent: number) => void
): Promise<TResponse> => {
  if (!file) {
    throw new Error("Файл не найден");
  }

  const formData = new FormData();
  formData.append("file", file);
  Object.keys(additionalData).forEach((key) => {
    formData.append(key, additionalData[key]);
  });

  try {
    const response = await apiClient.post<TResponse>(url, formData, {
      headers: {
        ...getAuthHeader(),
        ...headers,
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (event) => {
        if (event.total && onProgress) {
          const percent = Math.round((event.loaded / event.total) * 100);
          onProgress(percent);
        }
      },
    });

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export default apiFetchPost;
